import React, { useContext } from "react";
import Get_started from "../home/get_started/Get_started";
import Brands from "../home/brands/Brands";
import Our_role from "./our_role/Our_role";
import Internship_is_Ideal from "../common_components/internship_is_Ideal/Internship_is_Ideal";
import We_partner from "./we_partner/We_partner";
import Why_Choose_Ambassadeur from "./why_Choose_Ambassadeur/Why_Choose_Ambassadeur";
import Common_subHeading from "../common_components/common_subHeading/Common_subHeading";
import Life_at_Ambassadeur from "./life_at_Ambassadeur/Life_at_Ambassadeur";
import Programs_Offered_Through_AF from "./programs_Offered_Through_AF/Programs_Offered_Through_AF";
import Programs_Offered_card from "../common_components/study_abroad/programs_Offered_card/Programs_Offered_card";
import Our_Academic_Network from "./our_Academic_Network/Our_Academic_Network";
import Study_abroad_Banner from "./study_abroad_Banner/Study_abroad_Banner";
import { Context } from "../../utils/context";

function Study_abroad() {

  const {language} = useContext(Context);

  return (
    <>
      {/* <Study_abroad_Banner
        heading_Text="We nurture talent across the globe."
        text_normal_1="From Business pathways in France & the USA to MBBS pathways in Georgia and study
pathways in Korea. AFI supports students with a structured, ethical, and guided
process, before departure and after arrival."
      // textbold_1="trusted, accredited French business schools and international colleges "
      // text_normal_2=" that offer strong academic programs and a safe, multicultural environment."
      /> */}

      <Study_abroad_Banner
        heading_Text={language == 1 ? "We nurture talent across the globe." : "Nous cultivons les talents à travers le monde."}
        text_normal_1={language == 1 ? "From Business pathways in France & the USA to MBBS pathways in Georgia and studypathways in Korea. AFI supports students with a structured, ethical, and guidedprocess, before departure and after arrival." : "Des parcours en commerce en France et aux États-Unis aux cursus MBBS en Géorgie, en passant par les parcours d'études en Corée : AFI accompagne les étudiants à travers un processus structuré, éthique et guidé, tant avant leur départ qu'après leur arrivée."}
      />


      <Our_role />
      <Internship_is_Ideal
        normal_text={language == 1 ? "Studying abroad isn’t only about a degree" : "Étudier à l'étranger ne se résume pas à l'obtention d'un diplôme."}
        bold_text={language == 1 ? " — it’s about becoming globally confident, culturally aware, and professionally ready." : " — ll s’agit de gagner en assurance à l’échelle mondiale,d’acquérir une conscience culturelle et d’être prêt sur le plan professionnel."}
      />

      <Our_Academic_Network />

      <We_partner />

      <Internship_is_Ideal
        normal_text={language == 1 ? "Whether a student is aiming for business, management, international relations, or medicine, " : "Que l'étudiant vise des études en commerce, en gestion, en relations internationales ou en médecine,"}
        bold_text={language == 1 ? "we place them where they fit best.": " Nous les plaçons là où ils s'intègrent le mieux."}
      />

      <div className="container">
        <Common_subHeading subHeading={ language == 1 ? "Types of Institutions We Work With" : "Types d'institutions avec lesquelles nous travaillons" }/>
      </div>

      <Brands />
      <Programs_Offered_card
        reverse={false}
        title={language == 1 ? "Business Schools & Universities around the World" : "Écoles de commerce et universités à travers le monde"}
        image="/assets/images/study_abroad/new-images/Business-Schools.jpg"
        listBlocks={[
          {
            heading: language == 1 ? 
              "These	are	ideal	for	students	seeking	internationally	recognised programs	in	leading study destinations like France, the USA, and Korea. They offer" : "Ces programmes sont idéaux pour les étudiants à la recherche de formations reconnues à l'échelle internationale dans des destinations d'études de premier plan, telles que la France, les États-Unis et la Corée. Ils offrent", 
            points: language == 1 ? [
              "MBA / MIM / Master’s in Global Business",
              "Marketing, Luxury Management, Digital Strategy",
              "Finance, Business Analytics, Project Management",
            ] : [
              "MBA / MIM / Master en affaires internationales",
              "Marketing, gestion du luxe, stratégie digitale",
              "Finance, analyse commerciale, gestion de projet"
            ],
          },
          {
            heading: language == 1 ? "Key Benefits": "Principaux avantages",
            points: language == 1 ? [
              "Career-oriented curriculum and practical learning",
              "Internship and placement support (varies by institution)",
              "Strong international networks and industry exposure",
              "Study options in major academic hubs across destinations",
            ]: [
              "Programme axé sur la carrière et apprentissage pratique",
              "Accompagnement pour les stages et le placement professionnel (varie selon l'établissement)",
              "Solides réseaux internationaux et exposition au secteur",
              "Options d'études dans les principaux pôles universitaires, à travers diverses destinations."
            ],
          },
        ]}
      />

      <Internship_is_Ideal
        normal_text={language == 1 ? "These schools help students prepare for ": "Ces écoles aident les élèves à se préparer à "}
        bold_text={language == 1 ? "global roles in management, strategy, business development, and international markets." : "Rôles mondiaux dans la gestion, la stratégie, le développement commercial et les marchés internationaux."}
      />
      <Programs_Offered_card
        reverse={true}
        title={language == 1 ? "Medical Universities, MBBS Georgia" : "Universités de médecine – MBBS en Géorgie"}
        image="/assets/images/study_abroad/new-images/Medical-Universities.jpg"
        listBlocks={[
          {
            heading: language == 1 ?
              "A guided pathway for students pursuing medical education abroad through a clear, structured process." : "Un parcours guidé pour les étudiants poursuivant des études de médecine à l'étranger, s'appuyant sur un processus clair et structuré.",
            heading: language == 1 ? "What this pathway includes:": "Ce que comprend ce parcours :",
            points: language == 1 ? [
              "Eligibility guidance and university shortlisting",
              "Transparent documentation and admission steps",
              "Pre-departure preparation and relocation guidance",
              "Post-arrival support ",
            ] : [
              "Conseils en matière d'éligibilité et présélection d'universités",
              "Documentation et étapes d'admission transparentes",
              "Préparation au départ et accompagnement à la relocalisation",
              "Soutien après l'arrivée"
            ],
          },
          // {
          //   heading: "Why these colleges stand out",
          //   points: [
          //     "Affordable fee structures",
          //     "Flexible admission cycles",
          //     "Multicultural student population",
          //     "Small, interactive classes",
          //     "Industry-driven projects",
          //   ],
          // },
        ]}


      />

      <Internship_is_Ideal
        normal_text={language == 1 ? "Backed by structured ecosystem of guidance and support, students transition seamlessly, gain confidence early, and thrive in an English-taught medical environment." : "Soutenus par un écosystème structuré d'orientation et de soutien, les étudiants opèrent une transition fluide, gagnent rapidement en confiance et s'épanouissent dans un environnement médical anglophone."}
        bold_text=""
      />

      <Programs_Offered_card
        reverse={false}
        title={ language == 1 ? "Management & Applied Sciences Institutes" : "Instituts de gestion et de sciences appliquées"}
        image="/assets/images/study_abroad/new-images/Management.jpg"
        listBlocks={[
          {
            heading: language == 1 ?
              "Focused on practical teaching and real-world applications. They offer": "Axés sur l'enseignement pratique et les applications concrètes, ils proposent",
            points: language == 1 ? [
              "Business Studies",
              "International Management",
              "Applied Project Work",
              "Communication & Leadership Development",
              "Skill-based curriculum"
            ] : [
              "Études commerciales",
              "Management international",
              "Travaux de projet appliqué",
              "Développement de la communication et du leadership",
              "Programme d'études fondé sur les compétences"
            ],
          },
          {
            heading: language == 1 ? "Highlights": "Points forts",
            points: language == 1 ? [
              "Individual mentorship (where available)",
              "Project-based learning",
              "Industry-driven teaching approaches",
            ] : [
              "Mentorat individuel (lorsqu'il est disponible)",
              "Apprentissage par projets",
              "Approches pédagogiques axées sur l'industrie"
            ],
          },
        ]}
      />

      <Internship_is_Ideal
        normal_text={ language == 1 ? "Ideal for students who want  " : "Idéal pour les étudiants qui souhaitent "}
        bold_text={ language == 1 ? "hands-on learning and small-group academic environments. " : "un apprentissage pratique et des environnements académiques en petits groupes. "}
      />

      <Programs_Offered_Through_AF />

      <Life_at_Ambassadeur />
      <Programs_Offered_card
        reverse={false}
        title={ language == 1 ? "Student Life Abroad" : "La vie étudiante à l'étranger"}
        image="/assets/images/study_abroad/study_program/img_7.webp"
        listBlocks={[
          {
            heading: language == 1 ? "Studying abroad is also about confidence, independence, and cultural growth." : "Étudier à l'étranger, c'est aussi une question de confiance, d'indépendance et d'enrichissement culturel.",
            // heading:"Students gain",
            points: language == 1 ? [
              "Global exposure and personal development",
              "Multicultural community and new perspectives",
              "Better adaptability and professional readiness",
            ] : [
              "Exposition internationale et développement personnel",
              "Communauté multiculturelle et nouvelles perspectives",
              "Meilleure adaptabilité et préparation professionnelle"
            ],
          },
          {
            heading: language == 1 ? "AFI prepares students with" : "L'AFI prépare les étudiants avec",
            points: language == 1 ? [
              "Pre-departure cultural briefings",
              "Visa documentation support",
              "Accommodation guidance",
              "Arrival orientation",
              "Ongoing assistance during the program",
            ] : [
              "Séances d'information culturelle avant le départ",
              "Assistance pour les documents de visa",
              "Conseils en matière d'hébergement",
              "Séance d'orientation à l'arrivée",
              "Assistance continue tout au long du programme"
            ],
          },
        ]}
      />

      <Why_Choose_Ambassadeur />
      <Get_started />
    </>
  );
}

export default Study_abroad;
